 
import _ from 'underscore'
import service from '../service/refund'
import CONSTANT from '../constant/refund'

const getRefundList = ({ commit, state }, query) => {
    return new Promise((resolve, reject) => {
      return service.getRefundList(query).then(data => {
        if (_.isEmpty(data)) {
          resolve(data)
          commit(CONSTANT.REFUND_GET_LIST_EMPTY)
          return data
        }
        resolve(data)
        commit(CONSTANT.REFUND_GET_LIST_SUCCESS, data)
        return data
      }, e => {
        reject(e)
        commit(CONSTANT.REFUND_GET_LIST_ERROR, e)
      })
    })
  }
  const getRefundDetail = ({ commit, state }, query) => {
    return new Promise((resolve, reject) => {
      return service.getRefundDetail(query).then(data => {
        resolve(data)
        commit(CONSTANT.REFUND_GET_DETAIL_SUCCESS, data)
        return data
      }, e => {
        reject(e)
        commit(CONSTANT.REFUND_GET_DETAIL_ERROR, e)
      })
    })
  }
  const applyRefund = ({commit, state}, query) => {
    return new Promise((resolve, reject) => {
      return service.applyRefund(query).then(data => {
        resolve(data)
        return data
      }, e => {
        reject(e)
      })
    })
  }

  const getRefundReason = ({commit, state}, query) => {
    return new Promise((resolve, reject) => {
      return service.getRefundReason(query).then(data => {
        if(_.isEmpty(data)) {
          resolve(data)
          commit(CONSTANT.REFUND_GET_REASON_EMPTY)
          return data
        }
        resolve(data)
        commit(CONSTANT.REFUND_GET_REASON_SUCCESS, data)
        return data
      }, e => {
        reject(e)
        commit(CONSTANT.REFUND_GET_REASON_ERROR, e)        
      })
    })
  }
  
  const cancelRefund = ({commit, state}, query) => {
    return new Promise((resolve, reject) => {
      return service.cancelRefund(query).then(data => {
        resolve(data)
        return data
      }, e => {
        reject(e)
      })
    })
  }

  const getServiceType = ({commit, state}, query) => {
    return new Promise((resolve, reject) => {
      return service.getServiceType(query).then(data => {
        if(_.isEmpty(data)) {
          resolve(data)
          commit(CONSTANT.REFUND_GET_SERVICE_TYPE_EMPTY)
          return data
        }
        resolve(data)
        commit(CONSTANT.REFUND_GET_SERVICE_TYPE_SUCCESS, data)
        return data
      }, e => {
        reject(e)
        commit(CONSTANT.REFUND_GET_SERVICE_TYPE_ERROR, e)        
      })
    })
  }

  const getRefundAmountDetail = ({commit, state}, query) => {
    return new Promise((resolve, reject) => {
      return service.getRefundAmountDetail(query).then(data => {
        if(_.isEmpty(data)) {
          resolve(data)
          return data
        }
        commit(CONSTANT.REFUND_GET_AMOUNT_SUCCESS, data)
        resolve(data)
        return data
      }, e => {
        reject(e)
        commit(CONSTANT.REFUND_GET_AMOUNT_ERROR, e)
      })
    })
  }

  const getCompoanyList = ({commit, state}, query) => {
    return new Promise((resolve, reject) => {
      return service.getCompoanyList(query).then(data => {
        if(_.isEmpty(data)) {
          resolve(data)
          commit(CONSTANT.REFUND_GET_EXPRESS_COMPANY_LIST_EMPTY)
          return data
        }
        resolve(data)
        commit(CONSTANT.REFUND_GET_EXPRESS_COMPANY_LIST_SUCCESS, data)        
        return data
      }, e => {
        reject(e)
        commit(CONSTANT.REFUND_GET_EXPRESS_COMPANY_LIST_ERROR)        
      })
    })
  }

  const commitExpress = ({commit, state}, query) => {
    return new Promise((resolve, reject) => {
      return service.commitExpress(query).then(data => {
        resolve(data)
        return data
      }, e => {
        reject(e)
      })
    })
  }

  const checkRefundTime = ({commit, state}, query) => {
    return new Promise((resolve, reject) => {
      return service.checkRefundTime(query).then(data => {
        resolve(data)
        return data
      }, e => {
        reject(e)
      })
    })
  }
  const getRefundListMore = ({ commit, state }, query) => {
    return new Promise((resolve, reject) => {
      return service.getRefundList(query).then(data => {
        resolve(data)
        commit(CONSTANT.REFUND_GET_LIST_MORE_SUCCESS, data)
        return data
      }, e => {
        reject(e)
      })
    })
  }
  const uploadAfterSaleImage = ({commit, state}, query) => {
    return new Promise((resolve, reject) => {
      return service.uploadAfterSaleImage(query).then(data => {
        resolve(data)
        return data
      }, e => {
        reject(e)
      })
    })
  }
  const getRefundOptions = ({commit, state}, query) => {
    return new Promise((resolve, reject) => {
      return service.getRefundOptions(query).then(data => {
        if(_.isEmpty(data)) {
          resolve(data)
          commit(CONSTANT.REFUND_GET_RATE_OPTIONS_EMPTY)
          return data
        }
        resolve(data)
        commit(CONSTANT.REFUND_GET_RATE_OPTIONS_SUCCESS, data)        
        return data
      }, e => {
        reject(e)
        commit(CONSTANT.REFUND_GET_RATE_OPTIONS_ERROR)        
      })
    })
  }
  const confirmPickup = ({commit, state}, query) => {
    return new Promise((resolve, reject) => {
      return service.confirmPickup(query).then(data => {
        resolve(data)
        return data
      }, e => {
        reject(e)
      })
    })
  }
  const updateOrderAddress = ({commit, state}, query) => {
    return new Promise((resolve, reject) => {
      return service.updateOrderAddress(query).then(data => {
        resolve(data)
        return data
      }, e => {
        reject(e)
      })
    })
  }
  const getSelfServiceOrderList = ({commit, state}, query) => {
    return new Promise((resolve, reject) => {
      return service.getSelfServiceOrderList(query).then(data => {
        resolve(data)
        return data
      }, e => {
        reject(e)
      })
    })
  }
  
  const checkNeedFreightVoucher = ({commit, state}, query) => {
    return new Promise((resolve, reject) => {
      return service.checkNeedFreightVoucher(query).then(data => {
        resolve(data)
        return data
      }, e => {
        reject(e)
      })
    })
  }
  const getExpressFeeRule = ({commit, state}, query) => {
    return new Promise((resolve, reject) => {
      return service.getExpressFeeRule(query).then(data => {
        resolve(data)
        return data
      }, e => {
        reject(e)
      })
    })
  }
  

export default {
    getRefundList,
    getRefundDetail,
    applyRefund,
    getRefundReason,
    cancelRefund,
    getServiceType,
    getRefundAmountDetail,
    getCompoanyList,
    commitExpress,
    checkRefundTime,
    getRefundListMore,
    uploadAfterSaleImage,
    getRefundOptions,
    confirmPickup,
    updateOrderAddress,
    getSelfServiceOrderList,
    checkNeedFreightVoucher,
    getExpressFeeRule,
}
